import { createModelStore } from '@/shared/stores/create-model-store'
import { model7InitialModel } from './initial-state'
import { model7DimensionHandlers } from './dimensions'

export const useModel7Store = createModelStore({
  initialModel: model7InitialModel,
  dimensionHandlers: model7DimensionHandlers,
})
